import React from 'react';
import { cn } from '@lux/core';
export var ScrollToTopButtonContainer = function (props) {
    var _a = props.$isCTAOpen, $isCTAOpen = _a === void 0 ? false : _a, children = props.children;
    return (React.createElement("div", { className: cn('right-s fixed z-[999] transition-[bottom] duration-[166ms] ease-in-out', $isCTAOpen ? 'sm:bottom-s bottom-[100px]' : 'bottom-s') }, children));
};
